export default __webpack_public_path__ + "static/media/FC_2.ef0297c5.png";